import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const BoxIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M3.17 7.44L12 12.55L20.77 7.47" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M12 21.61V12.54" />

		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M9.93 2.48L4.59 5.44C3.38 6.11 2.39 7.79 2.39 9.17V14.82C2.39 16.2 3.38 17.88 4.59 18.55L9.93 21.52C11.07 22.15 12.94 22.15 14.08 21.52L19.42 18.55C20.63 17.88 21.62 16.2 21.62 14.82V9.17C21.62 7.79 20.63 6.11 19.42 5.44L14.08 2.47C12.93 1.84 11.07 1.84 9.93 2.48Z"
		/>

		<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M17 13.24V9.58L7.51 4.1" />
	</SvgIcon>
)

export default BoxIconAtom
